import { render, staticRenderFns } from "./table-page.vue?vue&type=template&id=11d97c66&"
import script from "./table-page.vue?vue&type=script&lang=js&"
export * from "./table-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports